import { useSelector } from 'react-redux'

import { selectUserConfiguration } from '@/features/domain/user'

export function useIsLoginAs() {
  const { isLoginAs } = useSelector(selectUserConfiguration)
  return isLoginAs
}
